// @flow

// Effect Managers
import { call, fork } from 'redux-saga/effects'

import { watchOperations } from 'hfty-operator-sampling-point'

// Controller
import controller from 'fc-ctrl-sampling-points'

export default function *main (): Generator<*, *, *> {
  yield call(controller.start)
  yield fork(controller.watch)
  yield fork(watchOperations)
}
